import { render, staticRenderFns } from "./AdminCourses.vue?vue&type=template&id=08d44623&scoped=true"
import script from "./AdminCourses.vue?vue&type=script&lang=js"
export * from "./AdminCourses.vue?vue&type=script&lang=js"
import style0 from "./AdminCourses.vue?vue&type=style&index=0&id=08d44623&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d44623",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d44623')) {
      api.createRecord('08d44623', component.options)
    } else {
      api.reload('08d44623', component.options)
    }
    module.hot.accept("./AdminCourses.vue?vue&type=template&id=08d44623&scoped=true", function () {
      api.rerender('08d44623', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminCourses.vue"
export default component.exports